import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../view/Index.vue";
import Login from "../view/Login.vue";
import Home from "../view/Home.vue";

import MyOwner from "../view/owner/MyOwner.vue";
import TaskCenter from "../view/owner/TaskCenter.vue";
import OwnerBookInfo from "../view/owner/OwnerBookInfo.vue";
import OwnerHighSeas from "../view/owner/OwnerHighSeas.vue";
import OwnerExamine from "../view/owner/OwnerExamine.vue";
import OwnerData from "../view/owner/OwnerData.vue";
import OwnerDayRecord from "../view/owner/OwnerDayRecord.vue";
import OwnerDaySheet from "../view/owner/OwnerDaySheet.vue";
import OwnerWeekRecord from "../view/owner/OwnerWeekRecord.vue";
import OwnerWeekSheet from "../view/owner/OwnerWeekSheet.vue";
import OwnerInfo from "../view/owner/OwnerInfo.vue";
import OwnerDemand from "../view/owner/OwnerDemand.vue";
import Cooperation from "../view/owner/Cooperation.vue";
import downloadFile from "../view/owner/downloadFile.vue";
import OwnerEdit from "../view/owner/OwnerEdit.vue";
import TaskEdit from "../view/owner/TaskEdit.vue";
import OwnerBookInfoEdit from "../view/owner/OwnerBookInfoEdit.vue";
import DownloadFileRecord from "../view/owner/DownloadFileRecord.vue";
import OwnerCheaterPool from "../view/owner/OwnerCheaterPool.vue";
import OwnerFeeExpenditure from "../view/owner/OwnerFeeExpenditure.vue";
import OwnerFeeExpenditureAdd from "../view/owner/OwnerFeeExpenditureAdd.vue";
import OwnerFeeIncome from "../view/owner/OwnerFeeIncome.vue";
import DownLoadManuscript from "../view/owner/DownLoadManuscript.vue";

import OwnerDayRecordMobile from "../view/owner/OwnerDayRecordMobile.vue";
import OwnerWeekRecordMobile from "../view/owner/OwnerWeekRecordMobile.vue";

import MyWriter from "../view/writer/MyWriter.vue";
import OrderCenter from "../view/writer/OrderCenter.vue";
import ManuscriptManage from "../view/writer/ManuscriptManage.vue";
import UploadManuscript from "../view/writer/UploadManuscript.vue";
import WriterBookInfo from "../view/writer/WriterBookInfo.vue";
import WriterHighSeas from "../view/writer/WriterHighSeas.vue";
import WriterInfo from "../view/writer/WriterInfo.vue";
import WriterExamine from "../view/writer/WriterExamine.vue";
import WriterData from "../view/writer/WriterData.vue";
import WriterDayRecord from "../view/writer/WriterDayRecord.vue";
import WriterDaySheet from "../view/writer/WriterDaySheet.vue";
import WriterWeekRecord from "../view/writer/WriterWeekRecord.vue";
import WriterWeekSheet from "../view/writer/WriterWeekSheet.vue";
import uploadFile from "../view/writer/uploadFile.vue";
import WriterEdit from "../view/writer/WriterEdit.vue";
import UploadFileRecord from "../view/writer/UploadFileRecord.vue";
import WriterCheaterPool from "../view/writer/WriterCheaterPool.vue";
import ManuscriptAdvance from "../view/writer/ManuscriptAdvance.vue";
import ManuscriptTemporary from "../view/writer/ManuscriptTemporary.vue";
import WriterFeeExpenditure from "../view/writer/WriterFeeExpenditure.vue";
import WriterFeeExpenditureAdd from "../view/writer/WriterFeeExpenditureAdd.vue";
import WriterFeeIncome from "../view/writer/WriterFeeIncome.vue";
import ManuscriptDeposit from "../view/writer/ManuscriptDeposit.vue";
import InitPressManuscript from "../view/writer/InitPressManuscript.vue";
import ManuscriptUpload from "../view/writer/ManuscriptUpload.vue";

import WriterDayRecordMobile from "../view/writer/WriterDayRecordMobile.vue";
import WriterWeekRecordMobile from "../view/writer/WriterWeekRecordMobile.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/home",
    component: Home
  },

  {
    path: "/downloadFile",
    component: downloadFile,
    meta: { title: "每日稿件下载" }
  },
  {
    path: "/uploadFile",
    component: uploadFile,
    meta: { title: "每日上传" }
  },
  {
    path: "/index",
    component: Index,
    children: [
      // {path:'/home',component:Home},

      { path: "/myOwner", component: MyOwner },
      { path: "/taskCenter", component: TaskCenter },
      { path: "/ownerBookInfo", component: OwnerBookInfo },
      { path: "/ownerHighSeas", component: OwnerHighSeas },
      { path: "/ownerExamine", component: OwnerExamine },
      { path: "/ownerData", component: OwnerData },
      { path: "/ownerDayRecord", component: OwnerDayRecord },
      { path: "/ownerDaySheet", component: OwnerDaySheet },
      { path: "/ownerWeekRecord", component: OwnerWeekRecord },
      { path: "/ownerWeekSheet", component: OwnerWeekSheet },
      { path: "/ownerInfo", component: OwnerInfo },
      { path: "/ownerDemand", component: OwnerDemand },
      { path: "/cooperation", component: Cooperation },
      { path: "/ownerEdit", component: OwnerEdit },
      { path: "/taskEdit", component: TaskEdit },
      { path: "/ownerBookInfoEdit", component: OwnerBookInfoEdit },
      { path: "/downloadFileRecord", component: DownloadFileRecord },
      { path: "/ownerCheaterPool", component: OwnerCheaterPool },
      { path: "/ownerFeeExpenditure", component: OwnerFeeExpenditure },
      { path: "/ownerFeeExpenditureAdd", component: OwnerFeeExpenditureAdd },
      { path: "/ownerFeeIncome", component: OwnerFeeIncome },
      { path: "/DownLoadManuscript", component: DownLoadManuscript },

      { path: "/ownerDayRecordMobile", component: OwnerDayRecordMobile },
      { path: "/ownerWeekRecordMobile", component: OwnerWeekRecordMobile },

      { path: "/myWriter", component: MyWriter },
      { path: "/orderCenter", component: OrderCenter },
      { path: "/manuscriptManage", component: ManuscriptManage },
      { path: "/uploadManuscript", component: UploadManuscript },
      { path: "/writerBookInfo", component: WriterBookInfo },
      { path: "/writerHighSeas", component: WriterHighSeas },
      { path: "/writerInfo", component: WriterInfo },
      { path: "/writerExamine", component: WriterExamine },
      { path: "/writerData", component: WriterData },
      { path: "/writerDayRecord", component: WriterDayRecord },
      { path: "/writerDaySheet", component: WriterDaySheet },
      { path: "/writerWeekRecord", component: WriterWeekRecord },
      { path: "/writerWeekSheet", component: WriterWeekSheet },
      { path: "/writerEdit", component: WriterEdit },
      { path: "/uploadFileRecord", component: UploadFileRecord },
      { path: "/writerCheaterPool", component: WriterCheaterPool },
      { path: "/manuscriptAdvance", component: ManuscriptAdvance },
      { path: "/manuscriptTemporary", component: ManuscriptTemporary },
      { path: "/writerFeeExpenditure", component: WriterFeeExpenditure },
      { path: "/writerFeeExpenditureAdd", component: WriterFeeExpenditureAdd },
      { path: "/writerFeeIncome", component: WriterFeeIncome },
      { path: "/manuscriptDeposit", component: ManuscriptDeposit },
      { path: "/initPressManuscript", component: InitPressManuscript },
      { path: "/manuscriptUpload", component: ManuscriptUpload },

      { path: "/writerDayRecordMobile", component: WriterDayRecordMobile },
      { path: "/writerWeekRecordMobile", component: WriterWeekRecordMobile }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js